import React from 'react';
import { SmallIcon, Text } from 'library';
import { Provider } from 'models';
import HandUpIcon from 'assets/icons/hand_up.svg';
import theme from 'theme';
import { useMediaQuery } from '@material-ui/core';

const JobTypesDetail = ({ provider }: { provider: Provider }) => {
    const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));
    const careTypes = provider.job_type_interest;

    const getCareTypeText = () => {
        if (careTypes.length <= 2) {
            return careTypes.map((careType) => careType.job_type.name).join(', ');
        }

        const [first, second, ...rest] = careTypes.map((careType) => careType.job_type.name);
        return `${first}, ${second}, and ${rest.length} more offerings`;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: xsOnly ? 44 : 36 }}>
            <SmallIcon icon={<HandUpIcon width={22} />} style={{ marginRight: 8 }} />
            <Text
                textStyle={{
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                }}
                variant={xsOnly ? 'body2' : 'body1'}
            >
                {getCareTypeText()}
            </Text>
        </div>
    );
};

export default JobTypesDetail;
